import React, { useEffect, useState } from 'react'
import { usePromoCodesByCatalogOsr } from '../../context'
import { getCustomerNumber } from '../../util'
import { ProductBrowseTiles } from '../home/productBrowseTiles'
import { useGetExcludeListDataByCustomerId } from '../hs-jwl/hooks'
import { ProductFilterTile } from '../hs-jwl/productFilterTile'
import { PhotoCardTiles } from './photoCardTiles'

export const HsGradProductBrowse = React.memo(({
    filterData,
    flavoredProductsPageContent,
    fromColGradAnnc,
    gradPaymentOptions,
    groupOsr,
    pageContent,
    pbData,
    googleAnalytics,
    schoolStoreEvents
}) => {
    const [filteredPbData, setFilteredPbData] = useState({})
    const [filteredItems, setFilteredQuickData] = useState([])
    const [selectedGroup, setSelectedGroup] = useState({})
    const [productData, setProductData] = useState({})
    const [productCount, setProductCount] = useState();

    const customerNumber = getCustomerNumber()
    const { promoCodes, excludeList } = usePromoCodesByCatalogOsr(pbData?.catalogOsr)
    const { isCustomerInCatalogExcludeList } = useGetExcludeListDataByCustomerId(
        excludeList, 
        pbData?.catalogOsr,
        customerNumber
    )
    
    const searchParamsItems = fromColGradAnnc
        ? groupOsr
        : new URLSearchParams(decodeURIComponent(window.location.search))?.get('filter');

    useEffect(() => {
        if (searchParamsItems && filterData && Object.keys(filterData)?.length === 0) {
            let searchParamFound = false
            const currentProductData = Object.keys(filteredPbData)?.length > 0
                ? { "products": filteredPbData.products }
                : { "products": pbData?.products?.sort((a, b) => a.orderSeq - b.orderSeq) }
            pageContent && pageContent.productFilters?.length > 0 &&
                pageContent.productFilters.forEach((ctaData) => {
                    if (ctaData.filterParam === searchParamsItems) {
                        searchParamFound = true
                        currentProductData.products?.length > 0 && currentProductData.products.forEach((prodData) => {
                            if(ctaData.filterRefValue?.split(",")?.length > 0) {
                                ctaData.filterRefValue?.split(",").forEach((refValue) => {
                                    if (prodData[ctaData.filterRefType] === refValue) {
                                        let searchedProducts = { "products": currentProductData.products?.filter((obj) => obj[ctaData.filterRefType] === refValue) }
                                        setProductData(searchedProducts)
                                        setProductCount(searchedProducts?.products?.length)
                                    }
                                })
                            }
                        })
                    }
                })
            if(!searchParamFound) {
                setProductData({
                    "products": currentProductData?.products
                        ? [...currentProductData.products]
                        : []
                })
            }
        } else {
            const filteredPbDataProducts = filteredPbData?.products ? [...filteredPbData?.products] : []
            const sortedPbDataProducts = pbData?.products?.length
                ? [...pbData?.products?.sort((a, b) => a.orderSeq - b.orderSeq)]
                : []

            setProductData(
                Object.keys(filteredPbData)?.length > 0
                    ? { "products": filteredPbDataProducts } 
                    : { "products": sortedPbDataProducts}
            )
        }
    }, [pbData, filteredPbData, searchParamsItems, pageContent])

    if (pbData) {
        const sectionTitle = pbData?.displayName ? pbData?.displayName : "Individual Products";
        const shouldDisplayPhotoCards = (flavoredProductsPageContent?.ctaCheck?.groupOsr?.split(",")?.length > 0 && flavoredProductsPageContent.ctaCheck.groupOsr
        .split(",")
        .find(ctaValue => ctaValue === searchParamsItems))

        return (
            <>
                <div className='mt-3'>
                    <span className="px-2 h5">{sectionTitle}</span>
                </div>
                <div className='container-fluid mb-4'><div className="pb-3 group-name"></div></div>
                {!filterData.message && (
                    <ProductFilterTile
                        pbData={pbData}
                        filteredPbData={filteredPbData}
                        filterData={filterData}
                        setFilteredPbData={setFilteredPbData}
                        selectedGroup={selectedGroup}
                        setFilteredQuickData={setFilteredQuickData}
                        filteredItems={filteredItems}
                        setSelectedGroup={setSelectedGroup}
                        productCount={productCount}
                    />
                )}
                {shouldDisplayPhotoCards
                    ? <PhotoCardTiles
                        pbData={productData}
                        pageContent={pageContent}
                        paymentOptions={gradPaymentOptions}
                        flavoredProductsPageContent={flavoredProductsPageContent}
                        filteredItems={filteredItems}
                        fromColGradAnnc={fromColGradAnnc}
                        googleAnalytics={googleAnalytics}
                        sectionTitle={sectionTitle}
                        promoCodes={promoCodes}
                        isCustomerInExcludeList={isCustomerInCatalogExcludeList}
                        schoolStoreEvents={schoolStoreEvents}
                    />
                    : <ProductBrowseTiles
                        pbData={productData}
                        pageContent={pageContent}
                        fromHsGrad={fromColGradAnnc ? false : true}
                        paymentOptions={gradPaymentOptions}
                        productInfo={{ "performSort": false }}
                        googleAnalytics={googleAnalytics}
                        sectionTitle={sectionTitle}
                        fromColGradAnnc={fromColGradAnnc}
                        promoCodes={promoCodes}
                        isCustomerInExcludeList={isCustomerInCatalogExcludeList}
                    />
                }
            </>
        )
    } else {
        return null
    }
})
